var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipantsActiveLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "rgba(35, 40, 52, 1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9286 50V52.7143H24.5V50C24.5 47.5714 27.9286 45.4286 32.3571 44.8571C32.5 44.4286 32.6429 44 32.6429 43.5714C32.6429 43.1429 32.5 42.7143 32.3571 42.4286C30.7857 41.4286 29.7857 39.4286 29.7857 37.2857C29.9286 34 32.2143 31.2857 35.2143 31.2857C38.2143 31.2857 40.6429 34 40.6429 37.2857C40.6429 39.4286 39.6429 41.4286 38.0714 42.4286C37.9286 42.8571 37.7857 43.1429 37.7857 43.5714C37.7857 44 37.9286 44.4286 38.0714 44.8571C42.5 45.4286 45.9286 47.5714 45.9286 50ZM54.5 31.2857H50.2143V27H47.3571V31.2857H43.0714V34.1429H47.3571V38.4286H50.2143V34.1429H54.5V31.2857Z",
    fill: "rgba(255, 255, 255, 1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 25.7143,
    fill: "white",
    transform: "translate(24.5 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantsActiveLight);
export default __webpack_public_path__ + "static/media/ParticipantsActiveLight.5ae2fe75ba296e498e7ee97f9b988916.svg";
export { ForwardRef as ReactComponent };